// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tn27","label":"styles_label__3-Ac2"};